import { useState } from "react";
import  "./UnqinessLevel.css";
const UnqinessLevel = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.uniquenesslevel===0?0:data.uniquenesslevel);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="UnqinessLevelCard" name="uniquenesslevel" onChange={onChangeValue}>
    <div class="UnqinessLevel-rating-container">
      
      <div class="UnqinessLevel-rating">
        <form class="UnqinessLevel-rating-form-1" >

          <label for={`UL1F-${count}`}>
            <input type="radio"  name="uniquenesslevel" class="UnqinessLevel1" id={`UL1F-${count}`}  value="6"  checked={'' + val === "6"} />
                <div className="aromacircle1"></div>
                <p>6</p>
           </label>
  
          <label for={`UL2F-${count}`}>
              <input type="radio" name="uniquenesslevel" class="UnqinessLevel2" id={`UL2F-${count}`} value="6.25" checked={'' + val === "6.25"} />
                <div className="aromacircle2"></div>
               <p className="invisible">.5</p>
           </label>
  
          <label for={`UL3F-${count}`}>
              <input type="radio" name="uniquenesslevel" class="UnqinessLevel3" id={`UL3F-${count}`} value="6.5" checked={'' + val === "6.5"} />
                <div className="aromacircle3"></div>
                <p className="invisible">.5</p>
            </label>
  
          <label for={`UL4F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel4" id={`UL4F-${count}`} value="6.75" checked={'' + val === "6.75"} />
               <div className="aromacircle4"></div>
               <p className="invisible">.5</p>
       
            </label>
  
          <label for={`UL5F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel5" id={`UL6F-${count}`} value="7" checked={'' + val === "7"} />
                <div className="aromacircle5"></div>
                <p>7</p>
             </label>
             <label for={`UL6F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel6" id={`UL6F-${count}`} value="7.25" checked={'' + val === "7.25"} />
                <div className="aromacircle6"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`UL7F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel7" id={`UL7F-${count}`} value="7.5" checked={'' + val === "7.5"} />
                <div className="aromacircle7"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`UL8F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel8" id={`UL8F-${count}`} value="7.75" checked={'' + val === "7.75"} />
                <div className="aromacircle8"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`UL9F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel9" id={`UL9F-${count}`} value="8" checked={'' + val === "8"} />
                <div className="aromacircle9"></div>
                <p>8</p>
                
             </label>

             <label for={`UL10F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel10" id={`UL10F-${count}`} value="8.25" checked={'' + val === "8.25"} />
                <div className="aromacircle10"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`UL11F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel11" id={`UL11F-${count}`} value="8.5" checked={'' + val === "8.5"} />
                <div className="aromacircle11"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`UL12F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel12" id={`UL12F-${count}`} value="8.75" checked={'' + val === "8.75"} />
                <div className="aromacircle12"></div>
                <p className="invisible">.5</p>
             </label>


             <label for={`UL13F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel13" id={`UL13F-${count}`} value="9" checked={'' + val === "9"} />
                <div className="aromacircle13"></div>
                
                <p>9</p>
             </label>

             <label for={`UL14F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel14" id={`UL14F-${count}`} value="9.25" checked={'' + val === "9.25"} />
                <div className="aromacircle14"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`UL15F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel15" id={`UL15F-${count}`} value="9.5" checked={'' + val === "9.5"} />
                <div className="aromacircle15"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`UL16F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel16" id={`UL16F-${count}`} value="9.75" checked={'' + val === "9.75"} />
                <div className="aromacircle16"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`UL17F-${count}`}>
             <input type="radio" name="uniquenesslevel" class="UnqinessLevel17" id={`UL17F-${count}`} value="10" checked={'' + val === "10"} />
                <div className="aromacircle17"></div>
                <p>10</p>
             </label>
        </form>
      </div>
    </div>
  </div>
  

    );
}

export default UnqinessLevel;